const DevPage = () => {
  return (
    <div>
      <h1>Development section</h1>
    </div>
  );
};

export default DevPage;
